module.exports = __webpack_public_path__ + "0ea2d531b9f76c7ef7e24af7c3db0c1f.svg";